/**
 * Token & user persistence — single source of truth.
 *
 * We keep the access token, refresh token, and current user profile in
 * localStorage. A `change` event fires when any of them is updated so other
 * tabs can react (logout-on-one-tab → logout-everywhere).
 */

const ACCESS_KEY = 'eaacc.accessToken';
const REFRESH_KEY = 'eaacc.refreshToken';
const USER_KEY = 'eaacc.user';

function read(key) {
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
}

function write(key, value) {
  try {
    if (value == null) window.localStorage.removeItem(key);
    else window.localStorage.setItem(key, value);
  } catch {
    /* ignore quota errors */
  }
}

export const tokenStore = {
  getAccessToken() {
    return read(ACCESS_KEY);
  },
  getRefreshToken() {
    return read(REFRESH_KEY);
  },
  getUser() {
    const raw = read(USER_KEY);
    if (!raw) return null;
    try {
      return JSON.parse(raw);
    } catch {
      return null;
    }
  },
  set(accessToken, refreshToken, user) {
    write(ACCESS_KEY, accessToken);
    write(REFRESH_KEY, refreshToken);
    write(USER_KEY, user ? JSON.stringify(user) : null);
    window.dispatchEvent(new CustomEvent('auth:changed'));
  },
  setUser(user) {
    write(USER_KEY, user ? JSON.stringify(user) : null);
    window.dispatchEvent(new CustomEvent('auth:changed'));
  },
  clear() {
    write(ACCESS_KEY, null);
    write(REFRESH_KEY, null);
    write(USER_KEY, null);
    window.dispatchEvent(new CustomEvent('auth:changed'));
  },
};
